import {HealthContent, HealthContentException, HealthTitle, HealthWrap} from "src/styles/views/Letter/health"
import { CustomBtn} from "src/styles/common/CommonForm/buttonform"
import {COLOR} from "src/service/constant/color"
import React, {useEffect, useState} from "react"
import {useParams} from "react-router"
import {useNavigate} from "react-router-dom"
import useWindowDimensions from "src/hooks/useGetWindowSize"
import {useLetterDetailDataQueryData} from "src/hooks/reactquery"
import {TYPE_HealthDetailData, TYPE_LifeDetailData} from "src/service/constant/cmdtype"
import {LetterDetailNextConts, LetterDetailWrap} from "src/styles/views/UserPage/letter"

const LetterDetail = (props: any) => {
    const {detailInfo} = props
    const params = useParams().idx
    const [CmdTypeState, setCmdTypeState] = useState(0)
    const {data: LetterDetailData, isSuccess} = useLetterDetailDataQueryData(CmdTypeState, Number(params))
    const navigate = useNavigate()
    const {width} = useWindowDimensions()

    useEffect(() => {
        if (detailInfo === "health") {
            setCmdTypeState(TYPE_HealthDetailData)
        } else {
            setCmdTypeState(TYPE_LifeDetailData)
        }
    }, [detailInfo])


    return (
        <LetterDetailWrap>
            {isSuccess &&
                <HealthWrap>
                    <HealthTitle
                        className={detailInfo}>{LetterDetailData?.Body?.HealthData?.Title ?? LetterDetailData?.Body?.LifeData?.Title}</HealthTitle>
                    <HealthContent>
                        {detailInfo === "health" &&
                            <img src={`https://${LetterDetailData?.Body?.HealthData?.ImgPath}`} alt='이미지'/>
                        }
                        {width > 1200 ?
                            <p dangerouslySetInnerHTML={{__html: LetterDetailData?.Body?.HealthData?.Contents ?? LetterDetailData?.Body?.LifeData?.Contents}}/>
                            : <HealthContentException size={`${width - 32}px`}
                                                      dangerouslySetInnerHTML={{__html: LetterDetailData?.Body?.HealthData?.Contents ?? LetterDetailData?.Body?.LifeData?.Contents}}/>
                        }
                    </HealthContent>
                </HealthWrap>
            }
            {isSuccess &&
                <LetterDetailNextConts>
                    <>
                        {width < 1200 && <h3>다음 이야기들도 둘러보세요.</h3>}
                        {(LetterDetailData?.Body?.NextHealthDataList ?? LetterDetailData?.Body?.NextLifeDataList)?.map((option: any) => (
                            <div key={option?.Idx}
                                 onClick={() => navigate(`/userPage/letter/${detailInfo}/detail/${option.Idx}`)}>
                                <img
                                    src={option?.ImgPath.indexOf('http') === 0 ? `${option.ImgPath}` : `https://${option?.ImgPath}`}
                                    alt={'다음 페이지 이미지'}/>
                                <p>{option?.Title}</p>
                            </div>
                        ))}
                    </>
                </LetterDetailNextConts>
            }
            <section>
                <CustomBtn
                    className={width > 1200 ? "health_btn_pc" : "health_btn_mo"}
                    color={COLOR.point1}
                    bgColor={COLOR.white}
                    borderRadius={"40px"}
                    borderColor={COLOR.point1}
                    marginTop={width > 1200 ? "92px" : "4px"}
                    width={width > 1200 ? "356px" : "328px"}
                    height={width > 1200 ? "56px" : "44px"}
                    fontSize={width > 1200 ? "18px" : "14px"}
                    fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                    onClick={() => navigate(`/userPage/letter/${detailInfo}`)}
                >
                    <span>목록보기</span>
                </CustomBtn>
            </section>
        </LetterDetailWrap>
    )
}
export default LetterDetail